import { render } from "./productListItem.vue?vue&type=template&id=65ff8490"
import script from "./productListItem.vue?vue&type=script&lang=js"
export * from "./productListItem.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/public_web/selllogix-vuecli/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__